import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import Loading from "../components/Loader";
import ProfilePage from "./Profile/ProfilePage";

import { API_URL } from "../utils/config";
import AuthContext from "../contexts/AuthProvider";

import { useContext } from "react";
const baseUrl = API_URL;

const Profile = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const path = searchParams.get("path"); // Get the 'query' param

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [profile, setProfile] = useState({});
const { isAuthenticated } = useContext(AuthContext);

  const navigate = useNavigate();
   const getLangFromLocalStorage = () => {
    return localStorage.getItem("language") || "en";
  };
  useEffect(() => {
    const fetchProfile = async () => {

      if (!isAuthenticated) {
        setError(new Error("No authentication token found. Please log in."));
        alert("No authentication token found. Please log in.");
        navigate("/");
        setLoading(false);
        return;
      }
      try {
        const profileResponse = await fetch(
          `${baseUrl}/api/v1/attnd-venue/auth/view-profile`,
          {
            method: "GET",
            credentials: "include",
            headers: {
              "Content-Type": "application/json",
              lang: getLangFromLocalStorage(),

            },
          }
        );

        if (!profileResponse.ok) {
          if (profileResponse.status === 401) {
            navigate("/login");
            throw new Error("Unauthorized access. Please log in again.");
          } else
            throw new Error(`An error occurred: ${profileResponse.statusText}`);
        }

        const profileData = await profileResponse.json();
        setProfile(profileData);
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchProfile();
  }, [baseUrl, path]);

  if (loading) {
    return (
      <div className="loader-container">
        <Loading />
      </div>
    );
  }

  if (error) {
    return (
      <div className={"PaddingPage"}>
        <div className="venue-venues-container">
          Error fetching Profile: {error.message}
        </div>
      </div>
    );
  }
  return <ProfilePage path={path} profile={profile.data} />;
};

export default Profile;
